<template>
  <div class="timeline">
    <div class="huigu_title">
      <div>
        <p><span>{{ timeList.list && timeList.list[0] && timeList.list[0].len }}<i>+</i></span>Session</p>
      </div>
      <div>
        <p>General Assembly</p>
      </div>
    </div>
    <div class="huigu_con">
      <ul class="pc">
        <li v-for="(item,index) in timeList.list" :key="'mpd_'+index">
          <div class="top">
            <div v-if="index%2==0">
              <div v-if="item.list" class="moretext">
                <slot v-for="(it,i) in item.list">
                  <p v-if="it.id!='3199'" :key="'mpd_'+index+'_'+i">
                    第{{item.len+i+1}}届<span>{{config[it.id].title}}站</span>
                  </p>
                </slot>
              </div>
              <div v-if="!item.list" class="not">
                <p>... ...</p>
              </div>
              <p>{{item.year}}</p>
              <div class="dot" @click="toReview()"></div>
            </div>
          </div>
          <div class="bottom">
            <div v-if="index%2!=0">
              <div class="dot" @click="toReview()"></div>
              <p>{{item.year}}</p>
              <div v-if="item.list" class="moretext">
                <p  v-for="(it,i) in item.list" :key="'mpd_'+index+'_'+i">
                  第{{item.len+i+1}}届<span>{{config[it.id].title}}站</span>
                </p>
              </div>
              <div v-if="!item.list" class="not">
                <p>... ...</p>
              </div>
            </div>
          </div>
        </li>
      </ul>
      <div class="mob">
        <div class="wrap-flex-center">
          <div class="morebtn">
            <router-link :to="formatHref('/review')">历届MPD</router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars */
import $ from 'jquery'
import { mixinSession } from '../mixin'

export default {
  mixins: [mixinSession],
  data () {
    return {
      config: []
    }
  },
  props: {
    // sid: global.area_id,
    timeList: {}
  },
  methods: {
    toReview: function () {
      this.$router.push({path: '/review', name: 'Review', query: {sid: this.global.area_id}})
    }
  },
  created () {
    this.config = this.global.config
  }
}
</script>

<style scoped lang="scss">
#app .timeline {
  width: 100%;
  height: 200px;
  * {
    text-align: left;
  }
  >div {
    float: left;
  }
  .huigu_title {
    width: 20%;
    div:nth-of-type(1) {
      height: 82px;
      position: relative;
      p {
        font-family: pingfang sc regular;
        font-size: 16px;
        font-weight: 400;
        position: absolute;
        bottom: 0;
        margin-bottom: 0;
        span {
          font-family: pingfang sc bold;
          font-size: 46px;
          font-weight: bold;
          margin-right: 5px;
          i {
            font-family: pingfang sc bold;
            font-size: 21px;
            font-style: normal;
            vertical-align: text-top;
            padding-left: 5px;
          }
        }
      }
    }
    div:nth-of-type(2) p {
      font-family: pingfang sc medium;
      font-size: 24px;
      font-weight: 500;
      padding-top: 5px;
    }
  }
  .huigu_con {
    width: 80%;
    ul, ul li, ul li div {
      &::after {
        content: '';
        display: inline-block;
        float: none !important;
        clear: both;
      }
    }
  }
  ul {
    list-style: none;
    li {
      float: left;
      width: 25%;
      >div {
        width: 100%;
      }
    }
  }
  .huigu_con ul li {
    div div {
      p {
        width: 100%;
        text-align: center;
        font-family: pingfang sc medium;
        font-size: 24px;
        font-weight: 500;
        line-height: 25px;
      }
      div p {
        position: initial;
        width: 80px;
        padding: 0;
        margin: 0 auto;
        font-family: pingfang sc regular;
        font-size: 12px;
        font-weight: 400;
        line-height: 16px;
        text-align: left;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
      }
      .not p {
        width: 23px;
        padding-top: 13px;
      }
    }
    &:nth-of-type(2) div div .moretext p {
      width: 115px;
      padding-left: 10px;
    }
    div div div p span {
      margin-left: 5px;
    }
  }
  .top {
    /* height: 80px; */
    height: 120px;
    position: relative;
    border-bottom: 1px solid #ffffff;
    >div {
      height: 100%;
      padding-bottom: 50px;
      display: grid;
      align-content: flex-end;
      align-items: flex-end;
    }
    div p {
      position: absolute;
      bottom: 0;
      padding-bottom: 17px;
      margin-bottom: 0;
    }
  }
  .bottom {
    position: relative;
    height: 125px;
    .moretext, .bottom .not {
      padding-top: 8px;
    }
    div p {
      padding-top: 25px;
      margin-bottom: 0;
    }
  }
  .dot {
    width: 18px;
    height: 18px;
    border: 4px solid #ffffff;
    border-radius: 50%;
    background-color: #1889cb;
    position: absolute;
    margin-left: 50%;
    left: -9px;
    z-index: 100;
    &:hover {
      border: 5px solid #333333;
      background-color: #ffffff;
      cursor: url("../../static/images/mouse1.png"), auto;
    }
  }
  .top .dot {
    bottom: -9px;
  }
  .bottom .dot {
    top: -9px;
  }
  .morebtn, .morebtn a {
    width: auto;
    margin: 0 auto;
  }
  @media(max-width:767px) {
    >div {
      float: none;
    }
    ul li {
      float: none;
      width: 90%;
      margin: 0 auto;
      >div {
        width: 50%;
        float: left;
      }
    }
    .huigu_con {
      width: 85%;
      margin: 0 auto;
    }
    .huigu_title {
      width: 100%;
      margin: 0 auto;
      div:nth-of-type(1) {
        height: 60px;
        p {
          left: 50%;
          transform: translateX(-50%);
        }
      }
      div:nth-of-type(2) {
        padding-bottom: 20px;
      }
      div {
        text-align: center;
        p {
          width: fit-content;
          min-width: 210px;
          margin: 0 auto;
          text-align: left;
        }
      }
    }
    .top, .bottom {
      height: 115px;
      .dot {
        top: 33px;
      }
      div p {
        padding-top: 30px;
      }
    }
    .top {
      border: none;
      border-right: 0.5px solid #ffffff;
      .dot {
        left: -8px;
        margin-left: 100%;
      }
      div {
        >p {
          top: 0;
          position: absolute;
          padding-right: 18px;
          text-align: right!important;
        }
        .moretext {
          margin: 0 auto;
          margin-top: 65px;
          p {
            padding: 0!important;
            text-align: left!important;
          }
        }
        .not {
          margin: 0 auto;
          margin-top: 45px;
        }
      }
    }
    .bottom {
      border-left: 0.5px solid #ffffff;
      .dot {
        left: -10px;
        margin-left: 0;
      }
      div>p {
        padding-left: 18px;
        text-align: left!important;
      }
    }
    .huigu_con ul li:nth-of-type(2) div div .moretext p {
      width: 110px;
    }
  }
  @media(max-width:600px) {
    .morebtn, .morebtn a {
      width: 100%;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/TimeLine.vue